import React from 'react';
import DatePickerPanelControls from '../../DatePicker/DatePickerPanelControls';
import { composedTextFieldWithoutValidations as TextField } from '../../TextField/TextField';
const GefTextFieldWrapper = ({ // mui ignored props
error, helperText, variant, InputProps, onChange, onKeyDown, validationError, TextFieldProps, panelControls, onClickPanelClear, handleClearChange = TextFieldProps.onChange, openOnlyByIcon, onClick: openPicker, ...other })=>{
    const datePanelControls = /*#__PURE__*/ React.createElement(DatePickerPanelControls, {
        controlPanelIconOpen: TextFieldProps.controlPanelIconOpen,
        disabled: other.disabled,
        value: other.value,
        clearable: TextFieldProps.clearable,
        onClear: ()=>{
            handleClearChange(null);
            onClickPanelClear?.();
        },
        readOnly: other.readOnly,
        onSelect: openPicker
    }, panelControls);
    return /*#__PURE__*/ React.createElement(TextField, {
        ...other,
        panelControls: datePanelControls,
        onInputWrapperClick: ()=>{
            if (!openOnlyByIcon) {
                openPicker();
            }
        },
        onChange: onChange ?? TextFieldProps.onChange
    });
};
export default GefTextFieldWrapper;
